import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const delegateApi = axios.create({ baseURL: `${BACKEND}/api` });

delegateApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("delegate_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
